import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';


@Injectable()
export class TakataRecallService {

  private serviceBulletinFilter: string;

  constructor(private http: HttpClient) { }

  getUserTakataRecallBulletins() {
    return this.http.get(`takata-recall/bulletins`, {withCredentials : true});
  }

  getTakataRecallVideos() {
    return this.http.get(`takata-recall/videos`, {withCredentials : true});
  }

  getTakataRecallDocuments() {
    return this.http.get(`takata-recall/documents`, {withCredentials : true});
  }

  saveFilterData(filter: string) {
    this.serviceBulletinFilter = filter;
  }

  getFilterData(): string {
    return this.serviceBulletinFilter;
  }

}
